import { DerivationListProps } from '../interfaces/DerivationProps';
import { OrangeLoader } from '@/components/loaders/OrangeLoader';
import { DerivationPreview } from './DerivationPreview';
import { TablePaginationComp } from '@/components/table/TablePagination';
import React from 'react';

const ErrorMsg = () => {
  return (
    <div className='flex items-center'>
      <p className='text-gray-500 italic text-center'>
        Vaya... parece que no hay ninguna derivación por el momento.
      </p>
    </div>
  );
};

interface ExtendedDerivationListProps extends DerivationListProps {
  newDerivations: Set<string>;
  totalItems?: number;
  totalPages?: number;
  currentPage?: number;
  pageSize?: number;
  onPageChange?: (page: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
}

export const DerivationList: React.FC<ExtendedDerivationListProps> = ({
  derivations,
  onSelect,
  selectedDerivation,
  isLoading,
  newDerivations,
  totalItems = 0,
  totalPages = 0,
  currentPage = 0,
  pageSize = 10,
  onPageChange,
  onPageSizeChange,
}) => {
  return (
    <div className='w-full bg-white rounded-lg shadow-md flex-grow flex flex-col overflow-hidden'>
      <div className='p-4 flex-shrink-0'>
        <h3 className='text-lg font-bold text-center'>Derivaciones</h3>
      </div>

      <div className='flex-grow overflow-auto px-4'>
        {isLoading && (
          <div className='flex items-center justify-center h-full'>
            <OrangeLoader />
          </div>
        )}
        {!isLoading && derivations.length === 0 && (
          <div className='flex items-center justify-center h-full'>
            <ErrorMsg />
          </div>
        )}
        {!isLoading && derivations.length > 0 && (
          <div className='w-full space-y-4 pb-4'>
            {derivations.map((d) => (
              <DerivationPreview
                key={d.id}
                derivationData={d}
                onSelect={onSelect}
                selectedDerivation={selectedDerivation}
                isNew={newDerivations.has(d.id)}
              />
            ))}
          </div>
        )}
      </div>

      {onPageChange && onPageSizeChange && totalItems > 0 && (
        <div className='flex-shrink-0 border-t border-gray-200'>
          <TablePaginationComp
            totalItems={totalItems}
            totalPages={totalPages}
            currentPage={currentPage + 1}
            rowsPerPage={pageSize}
            onPageChange={(newPage) => onPageChange(newPage - 1)}
            onRowsPerPageChange={onPageSizeChange}
          />
        </div>
      )}
    </div>
  );
};
